// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"796efaa1","83":"f0891d8d","211":"b13d5b6c","236":"0a07f3ab","285":"57d77c17","297":"7836915d","314":"fa6e6624","318":"2d1fca5a","469":"7beb047e","516":"99cd96b5","520":"7348e353","616":"32a85def","659":"ef54e26b","802":"aa1268f5","888":"32bf367a"}[chunkId] + ".chunk.js";
};